import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

type TrackExportImagesParams = {
  format: string;
  size?: string;
};

export const useTrackClickedCopyCDNLink = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedCopyCDNLink = useCallback(
    (params: TrackExportImagesParams) => {
      track(`Copy CDN link button clicked`, params);
    },
    [track],
  );

  return { trackClickedCopyCDNLink };
};
